export default __webpack_public_path__ + "static/media/iconchevronleft.306c77ad.svg";